import { css } from '@emotion/react';
import { theme } from 'global';

export const suggestionContainer = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  gap: 8px;
`;

export const suggestionHeader = css`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  white-space: nowrap;
`;

export const suggestionLabel = css`
  color: ${theme.colors.neutral[600]};
  margin: 0;
  white-space: nowrap;
`;

export const suggestionButton = css`
  background-color: ${theme.colors.white};
  border-radius: 4px;
  padding: 6px 8px;
  border: 1px solid ${theme.colors.neutral[200]};
  cursor: pointer;

  display: inline-flex;
  align-items: left;
  justify-content: left;
  color: ${theme.colors.neutral[600]};
  min-width: 0;
  max-width: 100%;
  white-space: pre-wrap;
  overflow: hidden;

  &:hover {
    background-color: ${theme.colors.neutral[50]};
    border-color: ${theme.colors.neutral[400]};
  }

  &:active {
    background-color: ${theme.colors.neutral[100]};
  }
`;

export const suggestionText = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;
